import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { ClearableInput } from "util/component/Input";

import axios from 'util/axios';


const UserTable = ({ children }) => {
    return (
        <table className={"bpl-table-default small"} style={{ width: "350px", fontSize: "13px" }}>
            <colgroup>
                <col width="100"></col>
                <col width="100"/>
                <col />
            </colgroup>
            {children}
        </table>
    );
};

const UserSearch = (props) => {
    const { disabled, project } = props;
    const [ SearchString, SetSearchString ] = useState("");
    const [ SearchType, SetSearchType ] = useState("userNmSearch");
    const [ Users, SetUsers ] = useState([]);
    const [ Loading, SetLoading ] = useState(false);

    const typeCheck = useRef(null);

    const HandleSetSearchString = (e) => {
        SetSearchString(e.target.value);
    }

    

    const HandleSetSearchType = (e) => {
        SetSearchType(e.target.id)
    }

    const searchUser = useCallback(async() => {
        SetLoading(true);
        let postData = {};
        postData[SearchType.toString().replace("Search",'')] = SearchString;
        postData.project = project.projectNm;
        const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/findReviewerList", postData)
        const result = response.data.data.result;
        SetUsers(result || [])
        SetLoading(false);
    },[SearchString, SearchType, project.projectNm])

    const renderUsers = useMemo(() => {
        if (Loading) {
            return <tr className={"noopt"}><td colSpan={2} style={{padding: "10px", textAlign:  "center"}}>Loading</td></tr>
        } else if(Users?.length > 0) {
            return Users.map((e,i) => {
                return <tr key={"foundUsers" + i} onClick={() => !disabled && props?.onUserSelect(e.userId)}>
                    <td>{e.userId}</td>
                    <td>{e.userNm}</td>
                    <td>{e.enDepartmentName}</td>
                </tr>
            })
        } else {
            return <tr className={"noopt"}><td colSpan={2} style={{padding: "10px", textAlign:  "center"}}>No Users</td></tr>
        }
    },[Loading, Users]);

    useEffect(() => {
        clearTimeout(typeCheck.current);
        if(SearchString.length > 2) {
            typeCheck.current = setTimeout(() => {
                searchUser();
            },300)
        }
    },[SearchString, SearchType, searchUser])

    return (
        <div style={{position: "relative"}}>
            {disabled && <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#000A",
                    zIndex: 50
                }}
            ></div>}
            <div style={{marginBottom: "5px"}}>
                <div className={"d-flex auto gap-10"}>
                    <div>
                        <input type={'radio'} name={"userSearch"} id={"userNmSearch"} onChange={HandleSetSearchType} 
                            checked={SearchType === "userNmSearch"}
                        />
                        <label htmlFor="userNmSearch"> User Name</label>
                    </div>
                    <div>
                        <input type={'radio'} name={"userSearch"} id={"userIdSearch"} onChange={HandleSetSearchType} 
                            checked={SearchType === "userIdSearch"}
                        />
                        <label htmlFor="userIdSearch"> User ID</label>
                    </div>
                </div>
                <div>
                    <ClearableInput
                        clear={SetSearchString}
                    >
                        <input type={'text'} style={{padding: "3px"}} onChange={HandleSetSearchString} value={SearchString || ""} />
                    </ClearableInput>
                </div>
            </div>
            <div>
                <div>
                    <UserTable>
                        <thead>
                        <tr>
                            <th>User ID</th>
                            <th>User Name</th>
                            <th>Department</th>
                        </tr>
                        </thead>
                    </UserTable>
                </div>
                <div style={{ maxHeight: "300px", overflow: "auto" }}>
                    <UserTable>
                        <tbody className={"user-search-table"}>{renderUsers}</tbody>
                    </UserTable>
                </div>
            </div>
        </div>
    );
};

export default UserSearch;